<!--
 * @Author: 付康 fukang@yuouhui.com
 * @Date: 2022-11-01 09:52:45
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-11-16 14:30:08
 * @FilePath: /wxkn-experience/src/components/MiPlaza.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="content">
    <div class="top-box">
      <van-nav-bar title="广场" />
      <div class="tab-box">
        <van-tabs
          :active="activeName"
          color="#3D7EFF"
          @click="handleTabsChange"
          :before-change="beforeChange"
        >
          <van-tab
            title="发现"
            name="discover"
            :title-style="
              activeName == 'discover'
                ? 'font-weight:600;font-size:16px'
                : 'font-weight:300;font-size:14px'
            "
          />
          <van-tab
            title="校园站"
            name="school"
            :title-style="
              activeName == 'school'
                ? 'font-weight:600;font-size:16px'
                : 'font-weight:300;font-size:14px'
            "
          />
        </van-tabs>
      </div>
    </div>
    <van-list class="data-list" @load="onReachBottom">
      <ProList :list="dataList" @shareAction="shareAction"></ProList>
    </van-list>
    <van-action-sheet
      v-model="showDialog"
      closeable
      title="使用微信扫码，进入小程序，体验更多功能"
    >
      <div class="popup-box">
        <div class="popup-title">
          <!-- 使用微信扫码，进入小程序，体验更多功能 -->
          <div class="popup-dsc">长按下载二维码</div>
        </div>
        <div class="qr-code-box">
          <MinProgram :title="''" :subTitle="''"></MinProgram>
          <el-button type="primary" plain @click="frontDownload"
            >本地下载</el-button
          >
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import ProList from "@/components/MiProlist.vue";
import util from "@/util/util";
import MinProgram from "@/components/MinProgram";

export default {
  data() {
    return {
      count: 0,
      isLoading: false,
      noteToken: "",
      topicList: [],
      schoolParams: {
        pageNo: 1,
        pageSize: 10,
        menu: 2,
        schoolName: "",
      },
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        menu: "1",
        keyword: "",
      },
      followParams: {
        pageNo: 1,
        pageSize: 10,
      },
      activeName: "discover",
      isNoData: true,
      dataList: [],
      followList: [],
      schoolList: [],
      userInfo: {},
      schoolData: {},
      keyWords: " ",
      showDialog: false,
    };
  },
  watch: {
    showDialog(n,o){

        if (this.showDialog == false){
            this.activeName = "discover"
        }
    }

  },
  components: {
    ProList,
    MinProgram,
  },
  mounted() {
    this.noteTokenAction(() => {
      this.getData();
    });
  },
  methods: {
    shareAction(){
          this.showDialog = true;
    },
    beforeChange(index){
        if (index == 1){
            return
        }

    },
    handleTabsChange(e) {
      this.showDialog = e == "school";
    },
    gotoDetail(e) {
      this.$emit("gotoDetail", e);
    },
    noteTokenAction(callBack) {
      let that = this;
      util.axiosFun(that, "xzxj/api/square/should/noteToken").then((res) => {
        that.noteToken = res.noteToken;
        callBack && callBack();
      });
    },
    getData(callBack) {
      let that = this;
      this.queryParams.noteToken = this.noteToken;
      util
        .axiosFun(that, "/xzxj/api/square/should/v1/noteList", this.queryParams)
        .then((res) => {
          let list = res.records;
          if (that.dataList.length == 0) {
            that.dataList = list;
          } else {
            that.dataList = [...that.dataList, ...list];
          }
          // if (this.dataList .length == res.result.total) {
          that.isNoData = list.length == res.total;
          callBack && callBack();
          // }
        });
    },
    getTopicList() {
      // let that = this;
      // util.axiosFun(that, "/xzxj/api/square/should/v1/noteList", this.para).then(res => {
      //     console.log('res', res);
      // })
    },
    onReachBottom() {
  
      if (!this.isNoData) {
        this.queryParams.pageNo += 1;
        if (this.queryParams.pageNo > 1) {
          this.getData();
        }
      }
    },

    onRefresh() {
      if (this.activeName == "school") {
        this.schoolParams.pageNo = 1;
        this.schoolList = [];
      } else if (this.activeName == "discover") {
        this.queryParams.pageNo = 1;
        this.dataList = [];
      } else {
        this.followParams.pageNo = 1;
        this.followList = [];
      }
      let that = this;
      this.getData(() => {
        that.isLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.van-pull-refresh {
  /* min-height: 100vh; */
  min-height: 100%;
}

.content {
  //   touch-action: none;
  //   touch-action: pan-y;
  overflow-x: hidden;
}

.tab-box {
  /* height: 60px;/ */
  width: 100vw;
  z-index: 9999;
}

.top-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
}

.data-list {
  // position: fixed;
  // left: 0;
  // right: 0;
  // top: 100px;
  // bottom: 64px;
  margin-top: 46px;
  margin-bottom: 80px;
}

.popup-box {
  /* height: 100%; */
  .popup-title {
    font-size: 15px;
    text-align: center;
  }
  .popup-dsc {
    font-size: 14px;
    color: #666;
    text-align: center;
    margin-top: 10px;
  }
}

.qr-code-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
}

.dialog-box{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/MiPlaza.vue